import * as ee from "react";
import Jr, { forwardRef as Kr, useContext as It, useState as Dt, useMemo as Mt, useCallback as Ft } from "react";
import { motion as jt, AnimatePresence as Yt } from "framer-motion";
import { InfoCircleIcon as Vt, ErrorCircleIcon as Lt, WarningCircleIcon as Wt, SuccessCircleIcon as zt, CloseIcon as Ut } from "@illa-design/icon";
import { css as Z } from "@emotion/react";
import { globalColor as re, illaPrefix as te, getColor as Zr, applyBoxStyle as qt, deleteCssProps as Bt } from "@illa-design/theme";
var cr = { exports: {} }, be = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var kr;
function Gt() {
  if (kr)
    return be;
  kr = 1;
  var e = Jr, r = Symbol.for("react.element"), n = Symbol.for("react.fragment"), a = Object.prototype.hasOwnProperty, o = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, i = { key: !0, ref: !0, __self: !0, __source: !0 };
  function f(l, p, m) {
    var d, y = {}, C = null, P = null;
    m !== void 0 && (C = "" + m), p.key !== void 0 && (C = "" + p.key), p.ref !== void 0 && (P = p.ref);
    for (d in p)
      a.call(p, d) && !i.hasOwnProperty(d) && (y[d] = p[d]);
    if (l && l.defaultProps)
      for (d in p = l.defaultProps, p)
        y[d] === void 0 && (y[d] = p[d]);
    return { $$typeof: r, type: l, key: C, ref: P, props: y, _owner: o.current };
  }
  return be.Fragment = n, be.jsx = f, be.jsxs = f, be;
}
var _e = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Ir;
function Jt() {
  return Ir || (Ir = 1, process.env.NODE_ENV !== "production" && function() {
    var e = Jr, r = Symbol.for("react.element"), n = Symbol.for("react.portal"), a = Symbol.for("react.fragment"), o = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), f = Symbol.for("react.provider"), l = Symbol.for("react.context"), p = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), d = Symbol.for("react.suspense_list"), y = Symbol.for("react.memo"), C = Symbol.for("react.lazy"), P = Symbol.for("react.offscreen"), $ = Symbol.iterator, g = "@@iterator";
    function D(t) {
      if (t === null || typeof t != "object")
        return null;
      var s = $ && t[$] || t[g];
      return typeof s == "function" ? s : null;
    }
    var _ = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function E(t) {
      {
        for (var s = arguments.length, u = new Array(s > 1 ? s - 1 : 0), h = 1; h < s; h++)
          u[h - 1] = arguments[h];
        N("error", t, u);
      }
    }
    function N(t, s, u) {
      {
        var h = _.ReactDebugCurrentFrame, S = h.getStackAddendum();
        S !== "" && (s += "%s", u = u.concat([S]));
        var k = u.map(function(x) {
          return String(x);
        });
        k.unshift("Warning: " + s), Function.prototype.apply.call(console[t], console, k);
      }
    }
    var I = !1, c = !1, Y = !1, A = !1, Ze = !1, $e;
    $e = Symbol.for("react.module.reference");
    function He(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === a || t === i || Ze || t === o || t === m || t === d || A || t === P || I || c || Y || typeof t == "object" && t !== null && (t.$$typeof === C || t.$$typeof === y || t.$$typeof === f || t.$$typeof === l || t.$$typeof === p || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === $e || t.getModuleId !== void 0));
    }
    function Xe(t, s, u) {
      var h = t.displayName;
      if (h)
        return h;
      var S = s.displayName || s.name || "";
      return S !== "" ? u + "(" + S + ")" : u;
    }
    function Ae(t) {
      return t.displayName || "Context";
    }
    function B(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && E("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case a:
          return "Fragment";
        case n:
          return "Portal";
        case i:
          return "Profiler";
        case o:
          return "StrictMode";
        case m:
          return "Suspense";
        case d:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var s = t;
            return Ae(s) + ".Consumer";
          case f:
            var u = t;
            return Ae(u._context) + ".Provider";
          case p:
            return Xe(t, t.render, "ForwardRef");
          case y:
            var h = t.displayName || null;
            return h !== null ? h : B(t.type) || "Memo";
          case C: {
            var S = t, k = S._payload, x = S._init;
            try {
              return B(x(k));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var X = Object.assign, ne = 0, Ne, ke, pe, Ie, ve, De, Me;
    function Fe() {
    }
    Fe.__reactDisabledLog = !0;
    function Qe() {
      {
        if (ne === 0) {
          Ne = console.log, ke = console.info, pe = console.warn, Ie = console.error, ve = console.group, De = console.groupCollapsed, Me = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: Fe,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ne++;
      }
    }
    function er() {
      {
        if (ne--, ne === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: X({}, t, {
              value: Ne
            }),
            info: X({}, t, {
              value: ke
            }),
            warn: X({}, t, {
              value: pe
            }),
            error: X({}, t, {
              value: Ie
            }),
            group: X({}, t, {
              value: ve
            }),
            groupCollapsed: X({}, t, {
              value: De
            }),
            groupEnd: X({}, t, {
              value: Me
            })
          });
        }
        ne < 0 && E("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var me = _.ReactCurrentDispatcher, he;
    function oe(t, s, u) {
      {
        if (he === void 0)
          try {
            throw Error();
          } catch (S) {
            var h = S.stack.trim().match(/\n( *(at )?)/);
            he = h && h[1] || "";
          }
        return `
` + he + t;
      }
    }
    var ye = !1, ie;
    {
      var rr = typeof WeakMap == "function" ? WeakMap : Map;
      ie = new rr();
    }
    function v(t, s) {
      if (!t || ye)
        return "";
      {
        var u = ie.get(t);
        if (u !== void 0)
          return u;
      }
      var h;
      ye = !0;
      var S = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var k;
      k = me.current, me.current = null, Qe();
      try {
        if (s) {
          var x = function() {
            throw Error();
          };
          if (Object.defineProperty(x.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(x, []);
            } catch (Q) {
              h = Q;
            }
            Reflect.construct(t, [], x);
          } else {
            try {
              x.call();
            } catch (Q) {
              h = Q;
            }
            t.call(x.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (Q) {
            h = Q;
          }
          t();
        }
      } catch (Q) {
        if (Q && h && typeof Q.stack == "string") {
          for (var b = Q.stack.split(`
`), W = h.stack.split(`
`), M = b.length - 1, F = W.length - 1; M >= 1 && F >= 0 && b[M] !== W[F]; )
            F--;
          for (; M >= 1 && F >= 0; M--, F--)
            if (b[M] !== W[F]) {
              if (M !== 1 || F !== 1)
                do
                  if (M--, F--, F < 0 || b[M] !== W[F]) {
                    var q = `
` + b[M].replace(" at new ", " at ");
                    return t.displayName && q.includes("<anonymous>") && (q = q.replace("<anonymous>", t.displayName)), typeof t == "function" && ie.set(t, q), q;
                  }
                while (M >= 1 && F >= 0);
              break;
            }
        }
      } finally {
        ye = !1, me.current = k, er(), Error.prepareStackTrace = S;
      }
      var fe = t ? t.displayName || t.name : "", Nr = fe ? oe(fe) : "";
      return typeof t == "function" && ie.set(t, Nr), Nr;
    }
    function Ee(t, s, u) {
      return v(t, !1);
    }
    function se(t) {
      var s = t.prototype;
      return !!(s && s.isReactComponent);
    }
    function ae(t, s, u) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return v(t, se(t));
      if (typeof t == "string")
        return oe(t);
      switch (t) {
        case m:
          return oe("Suspense");
        case d:
          return oe("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case p:
            return Ee(t.render);
          case y:
            return ae(t.type, s, u);
          case C: {
            var h = t, S = h._payload, k = h._init;
            try {
              return ae(k(S), s, u);
            } catch {
            }
          }
        }
      return "";
    }
    var je = Object.prototype.hasOwnProperty, br = {}, _r = _.ReactDebugCurrentFrame;
    function Ye(t) {
      if (t) {
        var s = t._owner, u = ae(t.type, t._source, s ? s.type : null);
        _r.setExtraStackFrame(u);
      } else
        _r.setExtraStackFrame(null);
    }
    function vt(t, s, u, h, S) {
      {
        var k = Function.call.bind(je);
        for (var x in t)
          if (k(t, x)) {
            var b = void 0;
            try {
              if (typeof t[x] != "function") {
                var W = Error((h || "React class") + ": " + u + " type `" + x + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[x] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw W.name = "Invariant Violation", W;
              }
              b = t[x](s, x, h, u, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (M) {
              b = M;
            }
            b && !(b instanceof Error) && (Ye(S), E("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", h || "React class", u, x, typeof b), Ye(null)), b instanceof Error && !(b.message in br) && (br[b.message] = !0, Ye(S), E("Failed %s type: %s", u, b.message), Ye(null));
          }
      }
    }
    var mt = Array.isArray;
    function tr(t) {
      return mt(t);
    }
    function ht(t) {
      {
        var s = typeof Symbol == "function" && Symbol.toStringTag, u = s && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return u;
      }
    }
    function yt(t) {
      try {
        return xr(t), !1;
      } catch {
        return !0;
      }
    }
    function xr(t) {
      return "" + t;
    }
    function Sr(t) {
      if (yt(t))
        return E("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", ht(t)), xr(t);
    }
    var ge = _.ReactCurrentOwner, Et = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, wr, Rr, nr;
    nr = {};
    function gt(t) {
      if (je.call(t, "ref")) {
        var s = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (s && s.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function bt(t) {
      if (je.call(t, "key")) {
        var s = Object.getOwnPropertyDescriptor(t, "key").get;
        if (s && s.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function _t(t, s) {
      if (typeof t.ref == "string" && ge.current && s && ge.current.stateNode !== s) {
        var u = B(ge.current.type);
        nr[u] || (E('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', B(ge.current.type), t.ref), nr[u] = !0);
      }
    }
    function xt(t, s) {
      {
        var u = function() {
          wr || (wr = !0, E("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", s));
        };
        u.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: u,
          configurable: !0
        });
      }
    }
    function St(t, s) {
      {
        var u = function() {
          Rr || (Rr = !0, E("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", s));
        };
        u.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: u,
          configurable: !0
        });
      }
    }
    var wt = function(t, s, u, h, S, k, x) {
      var b = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: r,
        // Built-in properties that belong on the element
        type: t,
        key: s,
        ref: u,
        props: x,
        // Record the component responsible for creating this element.
        _owner: k
      };
      return b._store = {}, Object.defineProperty(b._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(b, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: h
      }), Object.defineProperty(b, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: S
      }), Object.freeze && (Object.freeze(b.props), Object.freeze(b)), b;
    };
    function Rt(t, s, u, h, S) {
      {
        var k, x = {}, b = null, W = null;
        u !== void 0 && (Sr(u), b = "" + u), bt(s) && (Sr(s.key), b = "" + s.key), gt(s) && (W = s.ref, _t(s, S));
        for (k in s)
          je.call(s, k) && !Et.hasOwnProperty(k) && (x[k] = s[k]);
        if (t && t.defaultProps) {
          var M = t.defaultProps;
          for (k in M)
            x[k] === void 0 && (x[k] = M[k]);
        }
        if (b || W) {
          var F = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          b && xt(x, F), W && St(x, F);
        }
        return wt(t, b, W, S, h, ge.current, x);
      }
    }
    var ar = _.ReactCurrentOwner, Cr = _.ReactDebugCurrentFrame;
    function ce(t) {
      if (t) {
        var s = t._owner, u = ae(t.type, t._source, s ? s.type : null);
        Cr.setExtraStackFrame(u);
      } else
        Cr.setExtraStackFrame(null);
    }
    var or;
    or = !1;
    function ir(t) {
      return typeof t == "object" && t !== null && t.$$typeof === r;
    }
    function Tr() {
      {
        if (ar.current) {
          var t = B(ar.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function Ct(t) {
      {
        if (t !== void 0) {
          var s = t.fileName.replace(/^.*[\\\/]/, ""), u = t.lineNumber;
          return `

Check your code at ` + s + ":" + u + ".";
        }
        return "";
      }
    }
    var Or = {};
    function Tt(t) {
      {
        var s = Tr();
        if (!s) {
          var u = typeof t == "string" ? t : t.displayName || t.name;
          u && (s = `

Check the top-level render call using <` + u + ">.");
        }
        return s;
      }
    }
    function Pr(t, s) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var u = Tt(s);
        if (Or[u])
          return;
        Or[u] = !0;
        var h = "";
        t && t._owner && t._owner !== ar.current && (h = " It was passed a child from " + B(t._owner.type) + "."), ce(t), E('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', u, h), ce(null);
      }
    }
    function $r(t, s) {
      {
        if (typeof t != "object")
          return;
        if (tr(t))
          for (var u = 0; u < t.length; u++) {
            var h = t[u];
            ir(h) && Pr(h, s);
          }
        else if (ir(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var S = D(t);
          if (typeof S == "function" && S !== t.entries)
            for (var k = S.call(t), x; !(x = k.next()).done; )
              ir(x.value) && Pr(x.value, s);
        }
      }
    }
    function Ot(t) {
      {
        var s = t.type;
        if (s == null || typeof s == "string")
          return;
        var u;
        if (typeof s == "function")
          u = s.propTypes;
        else if (typeof s == "object" && (s.$$typeof === p || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        s.$$typeof === y))
          u = s.propTypes;
        else
          return;
        if (u) {
          var h = B(s);
          vt(u, t.props, "prop", h, t);
        } else if (s.PropTypes !== void 0 && !or) {
          or = !0;
          var S = B(s);
          E("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", S || "Unknown");
        }
        typeof s.getDefaultProps == "function" && !s.getDefaultProps.isReactClassApproved && E("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Pt(t) {
      {
        for (var s = Object.keys(t.props), u = 0; u < s.length; u++) {
          var h = s[u];
          if (h !== "children" && h !== "key") {
            ce(t), E("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", h), ce(null);
            break;
          }
        }
        t.ref !== null && (ce(t), E("Invalid attribute `ref` supplied to `React.Fragment`."), ce(null));
      }
    }
    function Ar(t, s, u, h, S, k) {
      {
        var x = He(t);
        if (!x) {
          var b = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (b += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var W = Ct(S);
          W ? b += W : b += Tr();
          var M;
          t === null ? M = "null" : tr(t) ? M = "array" : t !== void 0 && t.$$typeof === r ? (M = "<" + (B(t.type) || "Unknown") + " />", b = " Did you accidentally export a JSX literal instead of a component?") : M = typeof t, E("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", M, b);
        }
        var F = Rt(t, s, u, S, k);
        if (F == null)
          return F;
        if (x) {
          var q = s.children;
          if (q !== void 0)
            if (h)
              if (tr(q)) {
                for (var fe = 0; fe < q.length; fe++)
                  $r(q[fe], t);
                Object.freeze && Object.freeze(q);
              } else
                E("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              $r(q, t);
        }
        return t === a ? Pt(F) : Ot(F), F;
      }
    }
    function $t(t, s, u) {
      return Ar(t, s, u, !0);
    }
    function At(t, s, u) {
      return Ar(t, s, u, !1);
    }
    var Nt = At, kt = $t;
    _e.Fragment = a, _e.jsx = Nt, _e.jsxs = kt;
  }()), _e;
}
process.env.NODE_ENV === "production" ? cr.exports = Gt() : cr.exports = Jt();
var Re = cr.exports;
function Kt(e) {
  if (e.sheet)
    return e.sheet;
  for (var r = 0; r < document.styleSheets.length; r++)
    if (document.styleSheets[r].ownerNode === e)
      return document.styleSheets[r];
}
function Zt(e) {
  var r = document.createElement("style");
  return r.setAttribute("data-emotion", e.key), e.nonce !== void 0 && r.setAttribute("nonce", e.nonce), r.appendChild(document.createTextNode("")), r.setAttribute("data-s", ""), r;
}
var Ht = /* @__PURE__ */ function() {
  function e(n) {
    var a = this;
    this._insertTag = function(o) {
      var i;
      a.tags.length === 0 ? a.insertionPoint ? i = a.insertionPoint.nextSibling : a.prepend ? i = a.container.firstChild : i = a.before : i = a.tags[a.tags.length - 1].nextSibling, a.container.insertBefore(o, i), a.tags.push(o);
    }, this.isSpeedy = n.speedy === void 0 ? process.env.NODE_ENV === "production" : n.speedy, this.tags = [], this.ctr = 0, this.nonce = n.nonce, this.key = n.key, this.container = n.container, this.prepend = n.prepend, this.insertionPoint = n.insertionPoint, this.before = null;
  }
  var r = e.prototype;
  return r.hydrate = function(a) {
    a.forEach(this._insertTag);
  }, r.insert = function(a) {
    this.ctr % (this.isSpeedy ? 65e3 : 1) === 0 && this._insertTag(Zt(this));
    var o = this.tags[this.tags.length - 1];
    if (process.env.NODE_ENV !== "production") {
      var i = a.charCodeAt(0) === 64 && a.charCodeAt(1) === 105;
      i && this._alreadyInsertedOrderInsensitiveRule && console.error(`You're attempting to insert the following rule:
` + a + "\n\n`@import` rules must be before all other types of rules in a stylesheet but other rules have already been inserted. Please ensure that `@import` rules are before all other rules."), this._alreadyInsertedOrderInsensitiveRule = this._alreadyInsertedOrderInsensitiveRule || !i;
    }
    if (this.isSpeedy) {
      var f = Kt(o);
      try {
        f.insertRule(a, f.cssRules.length);
      } catch (l) {
        process.env.NODE_ENV !== "production" && !/:(-moz-placeholder|-moz-focus-inner|-moz-focusring|-ms-input-placeholder|-moz-read-write|-moz-read-only|-ms-clear|-ms-expand|-ms-reveal){/.test(a) && console.error('There was a problem inserting the following rule: "' + a + '"', l);
      }
    } else
      o.appendChild(document.createTextNode(a));
    this.ctr++;
  }, r.flush = function() {
    this.tags.forEach(function(a) {
      return a.parentNode && a.parentNode.removeChild(a);
    }), this.tags = [], this.ctr = 0, process.env.NODE_ENV !== "production" && (this._alreadyInsertedOrderInsensitiveRule = !1);
  }, e;
}(), L = "-ms-", Ue = "-moz-", w = "-webkit-", vr = "comm", mr = "rule", hr = "decl", Xt = "@import", Hr = "@keyframes", Qt = "@layer", en = Math.abs, Be = String.fromCharCode, rn = Object.assign;
function tn(e, r) {
  return V(e, 0) ^ 45 ? (((r << 2 ^ V(e, 0)) << 2 ^ V(e, 1)) << 2 ^ V(e, 2)) << 2 ^ V(e, 3) : 0;
}
function Xr(e) {
  return e.trim();
}
function nn(e, r) {
  return (e = r.exec(e)) ? e[0] : e;
}
function R(e, r, n) {
  return e.replace(r, n);
}
function fr(e, r) {
  return e.indexOf(r);
}
function V(e, r) {
  return e.charCodeAt(r) | 0;
}
function Ce(e, r, n) {
  return e.slice(r, n);
}
function K(e) {
  return e.length;
}
function yr(e) {
  return e.length;
}
function Ve(e, r) {
  return r.push(e), e;
}
function an(e, r) {
  return e.map(r).join("");
}
var Ge = 1, le = 1, Qr = 0, z = 0, j = 0, de = "";
function Je(e, r, n, a, o, i, f) {
  return { value: e, root: r, parent: n, type: a, props: o, children: i, line: Ge, column: le, length: f, return: "" };
}
function xe(e, r) {
  return rn(Je("", null, null, "", null, null, 0), e, { length: -e.length }, r);
}
function on() {
  return j;
}
function sn() {
  return j = z > 0 ? V(de, --z) : 0, le--, j === 10 && (le = 1, Ge--), j;
}
function U() {
  return j = z < Qr ? V(de, z++) : 0, le++, j === 10 && (le = 1, Ge++), j;
}
function H() {
  return V(de, z);
}
function Le() {
  return z;
}
function Pe(e, r) {
  return Ce(de, e, r);
}
function Te(e) {
  switch (e) {
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    case 59:
    case 123:
    case 125:
      return 4;
    case 58:
      return 3;
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    case 41:
    case 93:
      return 1;
  }
  return 0;
}
function et(e) {
  return Ge = le = 1, Qr = K(de = e), z = 0, [];
}
function rt(e) {
  return de = "", e;
}
function We(e) {
  return Xr(Pe(z - 1, ur(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function cn(e) {
  for (; (j = H()) && j < 33; )
    U();
  return Te(e) > 2 || Te(j) > 3 ? "" : " ";
}
function fn(e, r) {
  for (; --r && U() && !(j < 48 || j > 102 || j > 57 && j < 65 || j > 70 && j < 97); )
    ;
  return Pe(e, Le() + (r < 6 && H() == 32 && U() == 32));
}
function ur(e) {
  for (; U(); )
    switch (j) {
      case e:
        return z;
      case 34:
      case 39:
        e !== 34 && e !== 39 && ur(j);
        break;
      case 40:
        e === 41 && ur(e);
        break;
      case 92:
        U();
        break;
    }
  return z;
}
function un(e, r) {
  for (; U() && e + j !== 47 + 10; )
    if (e + j === 42 + 42 && H() === 47)
      break;
  return "/*" + Pe(r, z - 1) + "*" + Be(e === 47 ? e : U());
}
function ln(e) {
  for (; !Te(H()); )
    U();
  return Pe(e, z);
}
function dn(e) {
  return rt(ze("", null, null, null, [""], e = et(e), 0, [0], e));
}
function ze(e, r, n, a, o, i, f, l, p) {
  for (var m = 0, d = 0, y = f, C = 0, P = 0, $ = 0, g = 1, D = 1, _ = 1, E = 0, N = "", I = o, c = i, Y = a, A = N; D; )
    switch ($ = E, E = U()) {
      case 40:
        if ($ != 108 && V(A, y - 1) == 58) {
          fr(A += R(We(E), "&", "&\f"), "&\f") != -1 && (_ = -1);
          break;
        }
      case 34:
      case 39:
      case 91:
        A += We(E);
        break;
      case 9:
      case 10:
      case 13:
      case 32:
        A += cn($);
        break;
      case 92:
        A += fn(Le() - 1, 7);
        continue;
      case 47:
        switch (H()) {
          case 42:
          case 47:
            Ve(pn(un(U(), Le()), r, n), p);
            break;
          default:
            A += "/";
        }
        break;
      case 123 * g:
        l[m++] = K(A) * _;
      case 125 * g:
      case 59:
      case 0:
        switch (E) {
          case 0:
          case 125:
            D = 0;
          case 59 + d:
            _ == -1 && (A = R(A, /\f/g, "")), P > 0 && K(A) - y && Ve(P > 32 ? Mr(A + ";", a, n, y - 1) : Mr(R(A, " ", "") + ";", a, n, y - 2), p);
            break;
          case 59:
            A += ";";
          default:
            if (Ve(Y = Dr(A, r, n, m, d, o, l, N, I = [], c = [], y), i), E === 123)
              if (d === 0)
                ze(A, r, Y, Y, I, i, y, l, c);
              else
                switch (C === 99 && V(A, 3) === 110 ? 100 : C) {
                  case 100:
                  case 108:
                  case 109:
                  case 115:
                    ze(e, Y, Y, a && Ve(Dr(e, Y, Y, 0, 0, o, l, N, o, I = [], y), c), o, c, y, l, a ? I : c);
                    break;
                  default:
                    ze(A, Y, Y, Y, [""], c, 0, l, c);
                }
        }
        m = d = P = 0, g = _ = 1, N = A = "", y = f;
        break;
      case 58:
        y = 1 + K(A), P = $;
      default:
        if (g < 1) {
          if (E == 123)
            --g;
          else if (E == 125 && g++ == 0 && sn() == 125)
            continue;
        }
        switch (A += Be(E), E * g) {
          case 38:
            _ = d > 0 ? 1 : (A += "\f", -1);
            break;
          case 44:
            l[m++] = (K(A) - 1) * _, _ = 1;
            break;
          case 64:
            H() === 45 && (A += We(U())), C = H(), d = y = K(N = A += ln(Le())), E++;
            break;
          case 45:
            $ === 45 && K(A) == 2 && (g = 0);
        }
    }
  return i;
}
function Dr(e, r, n, a, o, i, f, l, p, m, d) {
  for (var y = o - 1, C = o === 0 ? i : [""], P = yr(C), $ = 0, g = 0, D = 0; $ < a; ++$)
    for (var _ = 0, E = Ce(e, y + 1, y = en(g = f[$])), N = e; _ < P; ++_)
      (N = Xr(g > 0 ? C[_] + " " + E : R(E, /&\f/g, C[_]))) && (p[D++] = N);
  return Je(e, r, n, o === 0 ? mr : l, p, m, d);
}
function pn(e, r, n) {
  return Je(e, r, n, vr, Be(on()), Ce(e, 2, -2), 0);
}
function Mr(e, r, n, a) {
  return Je(e, r, n, hr, Ce(e, 0, a), Ce(e, a + 1, -1), a);
}
function ue(e, r) {
  for (var n = "", a = yr(e), o = 0; o < a; o++)
    n += r(e[o], o, e, r) || "";
  return n;
}
function vn(e, r, n, a) {
  switch (e.type) {
    case Qt:
      if (e.children.length)
        break;
    case Xt:
    case hr:
      return e.return = e.return || e.value;
    case vr:
      return "";
    case Hr:
      return e.return = e.value + "{" + ue(e.children, a) + "}";
    case mr:
      e.value = e.props.join(",");
  }
  return K(n = ue(e.children, a)) ? e.return = e.value + "{" + n + "}" : "";
}
function mn(e) {
  var r = yr(e);
  return function(n, a, o, i) {
    for (var f = "", l = 0; l < r; l++)
      f += e[l](n, a, o, i) || "";
    return f;
  };
}
function hn(e) {
  return function(r) {
    r.root || (r = r.return) && e(r);
  };
}
function yn(e) {
  var r = /* @__PURE__ */ Object.create(null);
  return function(n) {
    return r[n] === void 0 && (r[n] = e(n)), r[n];
  };
}
var En = function(r, n, a) {
  for (var o = 0, i = 0; o = i, i = H(), o === 38 && i === 12 && (n[a] = 1), !Te(i); )
    U();
  return Pe(r, z);
}, gn = function(r, n) {
  var a = -1, o = 44;
  do
    switch (Te(o)) {
      case 0:
        o === 38 && H() === 12 && (n[a] = 1), r[a] += En(z - 1, n, a);
        break;
      case 2:
        r[a] += We(o);
        break;
      case 4:
        if (o === 44) {
          r[++a] = H() === 58 ? "&\f" : "", n[a] = r[a].length;
          break;
        }
      default:
        r[a] += Be(o);
    }
  while (o = U());
  return r;
}, bn = function(r, n) {
  return rt(gn(et(r), n));
}, Fr = /* @__PURE__ */ new WeakMap(), _n = function(r) {
  if (!(r.type !== "rule" || !r.parent || // positive .length indicates that this rule contains pseudo
  // negative .length indicates that this rule has been already prefixed
  r.length < 1)) {
    for (var n = r.value, a = r.parent, o = r.column === a.column && r.line === a.line; a.type !== "rule"; )
      if (a = a.parent, !a)
        return;
    if (!(r.props.length === 1 && n.charCodeAt(0) !== 58 && !Fr.get(a)) && !o) {
      Fr.set(r, !0);
      for (var i = [], f = bn(n, i), l = a.props, p = 0, m = 0; p < f.length; p++)
        for (var d = 0; d < l.length; d++, m++)
          r.props[m] = i[p] ? f[p].replace(/&\f/g, l[d]) : l[d] + " " + f[p];
    }
  }
}, xn = function(r) {
  if (r.type === "decl") {
    var n = r.value;
    // charcode for l
    n.charCodeAt(0) === 108 && // charcode for b
    n.charCodeAt(2) === 98 && (r.return = "", r.value = "");
  }
}, Sn = "emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason", wn = function(r) {
  return r.type === "comm" && r.children.indexOf(Sn) > -1;
}, Rn = function(r) {
  return function(n, a, o) {
    if (!(n.type !== "rule" || r.compat)) {
      var i = n.value.match(/(:first|:nth|:nth-last)-child/g);
      if (i) {
        for (var f = !!n.parent, l = f ? n.parent.children : (
          // global rule at the root level
          o
        ), p = l.length - 1; p >= 0; p--) {
          var m = l[p];
          if (m.line < n.line)
            break;
          if (m.column < n.column) {
            if (wn(m))
              return;
            break;
          }
        }
        i.forEach(function(d) {
          console.error('The pseudo class "' + d + '" is potentially unsafe when doing server-side rendering. Try changing it to "' + d.split("-child")[0] + '-of-type".');
        });
      }
    }
  };
}, tt = function(r) {
  return r.type.charCodeAt(1) === 105 && r.type.charCodeAt(0) === 64;
}, Cn = function(r, n) {
  for (var a = r - 1; a >= 0; a--)
    if (!tt(n[a]))
      return !0;
  return !1;
}, jr = function(r) {
  r.type = "", r.value = "", r.return = "", r.children = "", r.props = "";
}, Tn = function(r, n, a) {
  tt(r) && (r.parent ? (console.error("`@import` rules can't be nested inside other rules. Please move it to the top level and put it before regular rules. Keep in mind that they can only be used within global styles."), jr(r)) : Cn(n, a) && (console.error("`@import` rules can't be after other rules. Please put your `@import` rules before your other rules."), jr(r)));
};
function nt(e, r) {
  switch (tn(e, r)) {
    case 5103:
      return w + "print-" + e + e;
    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921:
    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005:
    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855:
    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return w + e + e;
    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return w + e + Ue + e + L + e + e;
    case 6828:
    case 4268:
      return w + e + L + e + e;
    case 6165:
      return w + e + L + "flex-" + e + e;
    case 5187:
      return w + e + R(e, /(\w+).+(:[^]+)/, w + "box-$1$2" + L + "flex-$1$2") + e;
    case 5443:
      return w + e + L + "flex-item-" + R(e, /flex-|-self/, "") + e;
    case 4675:
      return w + e + L + "flex-line-pack" + R(e, /align-content|flex-|-self/, "") + e;
    case 5548:
      return w + e + L + R(e, "shrink", "negative") + e;
    case 5292:
      return w + e + L + R(e, "basis", "preferred-size") + e;
    case 6060:
      return w + "box-" + R(e, "-grow", "") + w + e + L + R(e, "grow", "positive") + e;
    case 4554:
      return w + R(e, /([^-])(transform)/g, "$1" + w + "$2") + e;
    case 6187:
      return R(R(R(e, /(zoom-|grab)/, w + "$1"), /(image-set)/, w + "$1"), e, "") + e;
    case 5495:
    case 3959:
      return R(e, /(image-set\([^]*)/, w + "$1$`$1");
    case 4968:
      return R(R(e, /(.+:)(flex-)?(.*)/, w + "box-pack:$3" + L + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + w + e + e;
    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return R(e, /(.+)-inline(.+)/, w + "$1$2") + e;
    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      if (K(e) - 1 - r > 6)
        switch (V(e, r + 1)) {
          case 109:
            if (V(e, r + 4) !== 45)
              break;
          case 102:
            return R(e, /(.+:)(.+)-([^]+)/, "$1" + w + "$2-$3$1" + Ue + (V(e, r + 3) == 108 ? "$3" : "$2-$3")) + e;
          case 115:
            return ~fr(e, "stretch") ? nt(R(e, "stretch", "fill-available"), r) + e : e;
        }
      break;
    case 4949:
      if (V(e, r + 1) !== 115)
        break;
    case 6444:
      switch (V(e, K(e) - 3 - (~fr(e, "!important") && 10))) {
        case 107:
          return R(e, ":", ":" + w) + e;
        case 101:
          return R(e, /(.+:)([^;!]+)(;|!.+)?/, "$1" + w + (V(e, 14) === 45 ? "inline-" : "") + "box$3$1" + w + "$2$3$1" + L + "$2box$3") + e;
      }
      break;
    case 5936:
      switch (V(e, r + 11)) {
        case 114:
          return w + e + L + R(e, /[svh]\w+-[tblr]{2}/, "tb") + e;
        case 108:
          return w + e + L + R(e, /[svh]\w+-[tblr]{2}/, "tb-rl") + e;
        case 45:
          return w + e + L + R(e, /[svh]\w+-[tblr]{2}/, "lr") + e;
      }
      return w + e + L + e + e;
  }
  return e;
}
var On = function(r, n, a, o) {
  if (r.length > -1 && !r.return)
    switch (r.type) {
      case hr:
        r.return = nt(r.value, r.length);
        break;
      case Hr:
        return ue([xe(r, {
          value: R(r.value, "@", "@" + w)
        })], o);
      case mr:
        if (r.length)
          return an(r.props, function(i) {
            switch (nn(i, /(::plac\w+|:read-\w+)/)) {
              case ":read-only":
              case ":read-write":
                return ue([xe(r, {
                  props: [R(i, /:(read-\w+)/, ":" + Ue + "$1")]
                })], o);
              case "::placeholder":
                return ue([xe(r, {
                  props: [R(i, /:(plac\w+)/, ":" + w + "input-$1")]
                }), xe(r, {
                  props: [R(i, /:(plac\w+)/, ":" + Ue + "$1")]
                }), xe(r, {
                  props: [R(i, /:(plac\w+)/, L + "input-$1")]
                })], o);
            }
            return "";
          });
    }
}, Pn = [On], $n = function(r) {
  var n = r.key;
  if (process.env.NODE_ENV !== "production" && !n)
    throw new Error(`You have to configure \`key\` for your cache. Please make sure it's unique (and not equal to 'css') as it's used for linking styles to your cache.
If multiple caches share the same key they might "fight" for each other's style elements.`);
  if (n === "css") {
    var a = document.querySelectorAll("style[data-emotion]:not([data-s])");
    Array.prototype.forEach.call(a, function(g) {
      var D = g.getAttribute("data-emotion");
      D.indexOf(" ") !== -1 && (document.head.appendChild(g), g.setAttribute("data-s", ""));
    });
  }
  var o = r.stylisPlugins || Pn;
  if (process.env.NODE_ENV !== "production" && /[^a-z-]/.test(n))
    throw new Error('Emotion key must only contain lower case alphabetical characters and - but "' + n + '" was passed');
  var i = {}, f, l = [];
  f = r.container || document.head, Array.prototype.forEach.call(
    // this means we will ignore elements which don't have a space in them which
    // means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll('style[data-emotion^="' + n + ' "]'),
    function(g) {
      for (var D = g.getAttribute("data-emotion").split(" "), _ = 1; _ < D.length; _++)
        i[D[_]] = !0;
      l.push(g);
    }
  );
  var p, m = [_n, xn];
  process.env.NODE_ENV !== "production" && m.push(Rn({
    get compat() {
      return $.compat;
    }
  }), Tn);
  {
    var d, y = [vn, process.env.NODE_ENV !== "production" ? function(g) {
      g.root || (g.return ? d.insert(g.return) : g.value && g.type !== vr && d.insert(g.value + "{}"));
    } : hn(function(g) {
      d.insert(g);
    })], C = mn(m.concat(o, y)), P = function(D) {
      return ue(dn(D), C);
    };
    p = function(D, _, E, N) {
      d = E, process.env.NODE_ENV !== "production" && _.map !== void 0 && (d = {
        insert: function(c) {
          E.insert(c + _.map);
        }
      }), P(D ? D + "{" + _.styles + "}" : _.styles), N && ($.inserted[_.name] = !0);
    };
  }
  var $ = {
    key: n,
    sheet: new Ht({
      key: n,
      container: f,
      nonce: r.nonce,
      speedy: r.speedy,
      prepend: r.prepend,
      insertionPoint: r.insertionPoint
    }),
    nonce: r.nonce,
    inserted: i,
    registered: {},
    insert: p
  };
  return $.sheet.hydrate(l), $;
}, lr = { exports: {} }, T = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Yr;
function An() {
  if (Yr)
    return T;
  Yr = 1;
  var e = typeof Symbol == "function" && Symbol.for, r = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, a = e ? Symbol.for("react.fragment") : 60107, o = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, f = e ? Symbol.for("react.provider") : 60109, l = e ? Symbol.for("react.context") : 60110, p = e ? Symbol.for("react.async_mode") : 60111, m = e ? Symbol.for("react.concurrent_mode") : 60111, d = e ? Symbol.for("react.forward_ref") : 60112, y = e ? Symbol.for("react.suspense") : 60113, C = e ? Symbol.for("react.suspense_list") : 60120, P = e ? Symbol.for("react.memo") : 60115, $ = e ? Symbol.for("react.lazy") : 60116, g = e ? Symbol.for("react.block") : 60121, D = e ? Symbol.for("react.fundamental") : 60117, _ = e ? Symbol.for("react.responder") : 60118, E = e ? Symbol.for("react.scope") : 60119;
  function N(c) {
    if (typeof c == "object" && c !== null) {
      var Y = c.$$typeof;
      switch (Y) {
        case r:
          switch (c = c.type, c) {
            case p:
            case m:
            case a:
            case i:
            case o:
            case y:
              return c;
            default:
              switch (c = c && c.$$typeof, c) {
                case l:
                case d:
                case $:
                case P:
                case f:
                  return c;
                default:
                  return Y;
              }
          }
        case n:
          return Y;
      }
    }
  }
  function I(c) {
    return N(c) === m;
  }
  return T.AsyncMode = p, T.ConcurrentMode = m, T.ContextConsumer = l, T.ContextProvider = f, T.Element = r, T.ForwardRef = d, T.Fragment = a, T.Lazy = $, T.Memo = P, T.Portal = n, T.Profiler = i, T.StrictMode = o, T.Suspense = y, T.isAsyncMode = function(c) {
    return I(c) || N(c) === p;
  }, T.isConcurrentMode = I, T.isContextConsumer = function(c) {
    return N(c) === l;
  }, T.isContextProvider = function(c) {
    return N(c) === f;
  }, T.isElement = function(c) {
    return typeof c == "object" && c !== null && c.$$typeof === r;
  }, T.isForwardRef = function(c) {
    return N(c) === d;
  }, T.isFragment = function(c) {
    return N(c) === a;
  }, T.isLazy = function(c) {
    return N(c) === $;
  }, T.isMemo = function(c) {
    return N(c) === P;
  }, T.isPortal = function(c) {
    return N(c) === n;
  }, T.isProfiler = function(c) {
    return N(c) === i;
  }, T.isStrictMode = function(c) {
    return N(c) === o;
  }, T.isSuspense = function(c) {
    return N(c) === y;
  }, T.isValidElementType = function(c) {
    return typeof c == "string" || typeof c == "function" || c === a || c === m || c === i || c === o || c === y || c === C || typeof c == "object" && c !== null && (c.$$typeof === $ || c.$$typeof === P || c.$$typeof === f || c.$$typeof === l || c.$$typeof === d || c.$$typeof === D || c.$$typeof === _ || c.$$typeof === E || c.$$typeof === g);
  }, T.typeOf = N, T;
}
var O = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Vr;
function Nn() {
  return Vr || (Vr = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, r = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, a = e ? Symbol.for("react.fragment") : 60107, o = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, f = e ? Symbol.for("react.provider") : 60109, l = e ? Symbol.for("react.context") : 60110, p = e ? Symbol.for("react.async_mode") : 60111, m = e ? Symbol.for("react.concurrent_mode") : 60111, d = e ? Symbol.for("react.forward_ref") : 60112, y = e ? Symbol.for("react.suspense") : 60113, C = e ? Symbol.for("react.suspense_list") : 60120, P = e ? Symbol.for("react.memo") : 60115, $ = e ? Symbol.for("react.lazy") : 60116, g = e ? Symbol.for("react.block") : 60121, D = e ? Symbol.for("react.fundamental") : 60117, _ = e ? Symbol.for("react.responder") : 60118, E = e ? Symbol.for("react.scope") : 60119;
    function N(v) {
      return typeof v == "string" || typeof v == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      v === a || v === m || v === i || v === o || v === y || v === C || typeof v == "object" && v !== null && (v.$$typeof === $ || v.$$typeof === P || v.$$typeof === f || v.$$typeof === l || v.$$typeof === d || v.$$typeof === D || v.$$typeof === _ || v.$$typeof === E || v.$$typeof === g);
    }
    function I(v) {
      if (typeof v == "object" && v !== null) {
        var Ee = v.$$typeof;
        switch (Ee) {
          case r:
            var se = v.type;
            switch (se) {
              case p:
              case m:
              case a:
              case i:
              case o:
              case y:
                return se;
              default:
                var ae = se && se.$$typeof;
                switch (ae) {
                  case l:
                  case d:
                  case $:
                  case P:
                  case f:
                    return ae;
                  default:
                    return Ee;
                }
            }
          case n:
            return Ee;
        }
      }
    }
    var c = p, Y = m, A = l, Ze = f, $e = r, He = d, Xe = a, Ae = $, B = P, X = n, ne = i, Ne = o, ke = y, pe = !1;
    function Ie(v) {
      return pe || (pe = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), ve(v) || I(v) === p;
    }
    function ve(v) {
      return I(v) === m;
    }
    function De(v) {
      return I(v) === l;
    }
    function Me(v) {
      return I(v) === f;
    }
    function Fe(v) {
      return typeof v == "object" && v !== null && v.$$typeof === r;
    }
    function Qe(v) {
      return I(v) === d;
    }
    function er(v) {
      return I(v) === a;
    }
    function me(v) {
      return I(v) === $;
    }
    function he(v) {
      return I(v) === P;
    }
    function oe(v) {
      return I(v) === n;
    }
    function ye(v) {
      return I(v) === i;
    }
    function ie(v) {
      return I(v) === o;
    }
    function rr(v) {
      return I(v) === y;
    }
    O.AsyncMode = c, O.ConcurrentMode = Y, O.ContextConsumer = A, O.ContextProvider = Ze, O.Element = $e, O.ForwardRef = He, O.Fragment = Xe, O.Lazy = Ae, O.Memo = B, O.Portal = X, O.Profiler = ne, O.StrictMode = Ne, O.Suspense = ke, O.isAsyncMode = Ie, O.isConcurrentMode = ve, O.isContextConsumer = De, O.isContextProvider = Me, O.isElement = Fe, O.isForwardRef = Qe, O.isFragment = er, O.isLazy = me, O.isMemo = he, O.isPortal = oe, O.isProfiler = ye, O.isStrictMode = ie, O.isSuspense = rr, O.isValidElementType = N, O.typeOf = I;
  }()), O;
}
process.env.NODE_ENV === "production" ? lr.exports = An() : lr.exports = Nn();
var kn = lr.exports, at = kn, In = {
  $$typeof: !0,
  render: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0
}, Dn = {
  $$typeof: !0,
  compare: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0,
  type: !0
}, ot = {};
ot[at.ForwardRef] = In;
ot[at.Memo] = Dn;
var Mn = !0;
function Fn(e, r, n) {
  var a = "";
  return n.split(" ").forEach(function(o) {
    e[o] !== void 0 ? r.push(e[o] + ";") : a += o + " ";
  }), a;
}
var it = function(r, n, a) {
  var o = r.key + "-" + n.name;
  // we only need to add the styles to the registered cache if the
  // class name could be used further down
  // the tree but if it's a string tag, we know it won't
  // so we don't have to add it to registered cache.
  // this improves memory usage since we can avoid storing the whole style string
  (a === !1 || // we need to always store it if we're in compat mode and
  // in node since emotion-server relies on whether a style is in
  // the registered cache to know whether a style is global or not
  // also, note that this check will be dead code eliminated in the browser
  Mn === !1) && r.registered[o] === void 0 && (r.registered[o] = n.styles);
}, jn = function(r, n, a) {
  it(r, n, a);
  var o = r.key + "-" + n.name;
  if (r.inserted[n.name] === void 0) {
    var i = n;
    do
      r.insert(n === i ? "." + o : "", i, r.sheet, !0), i = i.next;
    while (i !== void 0);
  }
};
function Yn(e) {
  for (var r = 0, n, a = 0, o = e.length; o >= 4; ++a, o -= 4)
    n = e.charCodeAt(a) & 255 | (e.charCodeAt(++a) & 255) << 8 | (e.charCodeAt(++a) & 255) << 16 | (e.charCodeAt(++a) & 255) << 24, n = /* Math.imul(k, m): */
    (n & 65535) * 1540483477 + ((n >>> 16) * 59797 << 16), n ^= /* k >>> r: */
    n >>> 24, r = /* Math.imul(k, m): */
    (n & 65535) * 1540483477 + ((n >>> 16) * 59797 << 16) ^ /* Math.imul(h, m): */
    (r & 65535) * 1540483477 + ((r >>> 16) * 59797 << 16);
  switch (o) {
    case 3:
      r ^= (e.charCodeAt(a + 2) & 255) << 16;
    case 2:
      r ^= (e.charCodeAt(a + 1) & 255) << 8;
    case 1:
      r ^= e.charCodeAt(a) & 255, r = /* Math.imul(h, m): */
      (r & 65535) * 1540483477 + ((r >>> 16) * 59797 << 16);
  }
  return r ^= r >>> 13, r = /* Math.imul(h, m): */
  (r & 65535) * 1540483477 + ((r >>> 16) * 59797 << 16), ((r ^ r >>> 15) >>> 0).toString(36);
}
var Vn = {
  animationIterationCount: 1,
  aspectRatio: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
}, Lr = `You have illegal escape sequence in your template literal, most likely inside content's property value.
Because you write your CSS inside a JavaScript string you actually have to do double escaping, so for example "content: '\\00d7';" should become "content: '\\\\00d7';".
You can read more about this here:
https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences`, Ln = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).", Wn = /[A-Z]|^ms/g, st = /_EMO_([^_]+?)_([^]*?)_EMO_/g, Er = function(r) {
  return r.charCodeAt(1) === 45;
}, Wr = function(r) {
  return r != null && typeof r != "boolean";
}, sr = /* @__PURE__ */ yn(function(e) {
  return Er(e) ? e : e.replace(Wn, "-$&").toLowerCase();
}), qe = function(r, n) {
  switch (r) {
    case "animation":
    case "animationName":
      if (typeof n == "string")
        return n.replace(st, function(a, o, i) {
          return J = {
            name: o,
            styles: i,
            next: J
          }, o;
        });
  }
  return Vn[r] !== 1 && !Er(r) && typeof n == "number" && n !== 0 ? n + "px" : n;
};
if (process.env.NODE_ENV !== "production") {
  var zn = /(var|attr|counters?|url|element|(((repeating-)?(linear|radial))|conic)-gradient)\(|(no-)?(open|close)-quote/, Un = ["normal", "none", "initial", "inherit", "unset"], qn = qe, Bn = /^-ms-/, Gn = /-(.)/g, zr = {};
  qe = function(r, n) {
    if (r === "content" && (typeof n != "string" || Un.indexOf(n) === -1 && !zn.test(n) && (n.charAt(0) !== n.charAt(n.length - 1) || n.charAt(0) !== '"' && n.charAt(0) !== "'")))
      throw new Error("You seem to be using a value for 'content' without quotes, try replacing it with `content: '\"" + n + "\"'`");
    var a = qn(r, n);
    return a !== "" && !Er(r) && r.indexOf("-") !== -1 && zr[r] === void 0 && (zr[r] = !0, console.error("Using kebab-case for css properties in objects is not supported. Did you mean " + r.replace(Bn, "ms-").replace(Gn, function(o, i) {
      return i.toUpperCase();
    }) + "?")), a;
  };
}
var ct = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function Oe(e, r, n) {
  if (n == null)
    return "";
  if (n.__emotion_styles !== void 0) {
    if (process.env.NODE_ENV !== "production" && n.toString() === "NO_COMPONENT_SELECTOR")
      throw new Error(ct);
    return n;
  }
  switch (typeof n) {
    case "boolean":
      return "";
    case "object": {
      if (n.anim === 1)
        return J = {
          name: n.name,
          styles: n.styles,
          next: J
        }, n.name;
      if (n.styles !== void 0) {
        var a = n.next;
        if (a !== void 0)
          for (; a !== void 0; )
            J = {
              name: a.name,
              styles: a.styles,
              next: J
            }, a = a.next;
        var o = n.styles + ";";
        return process.env.NODE_ENV !== "production" && n.map !== void 0 && (o += n.map), o;
      }
      return Jn(e, r, n);
    }
    case "function": {
      if (e !== void 0) {
        var i = J, f = n(e);
        return J = i, Oe(e, r, f);
      } else
        process.env.NODE_ENV !== "production" && console.error("Functions that are interpolated in css calls will be stringified.\nIf you want to have a css call based on props, create a function that returns a css call like this\nlet dynamicStyle = (props) => css`color: ${props.color}`\nIt can be called directly with props or interpolated in a styled call like this\nlet SomeComponent = styled('div')`${dynamicStyle}`");
      break;
    }
    case "string":
      if (process.env.NODE_ENV !== "production") {
        var l = [], p = n.replace(st, function(d, y, C) {
          var P = "animation" + l.length;
          return l.push("const " + P + " = keyframes`" + C.replace(/^@keyframes animation-\w+/, "") + "`"), "${" + P + "}";
        });
        l.length && console.error("`keyframes` output got interpolated into plain string, please wrap it with `css`.\n\nInstead of doing this:\n\n" + [].concat(l, ["`" + p + "`"]).join(`
`) + `

You should wrap it with \`css\` like this:

` + ("css`" + p + "`"));
      }
      break;
  }
  if (r == null)
    return n;
  var m = r[n];
  return m !== void 0 ? m : n;
}
function Jn(e, r, n) {
  var a = "";
  if (Array.isArray(n))
    for (var o = 0; o < n.length; o++)
      a += Oe(e, r, n[o]) + ";";
  else
    for (var i in n) {
      var f = n[i];
      if (typeof f != "object")
        r != null && r[f] !== void 0 ? a += i + "{" + r[f] + "}" : Wr(f) && (a += sr(i) + ":" + qe(i, f) + ";");
      else {
        if (i === "NO_COMPONENT_SELECTOR" && process.env.NODE_ENV !== "production")
          throw new Error(ct);
        if (Array.isArray(f) && typeof f[0] == "string" && (r == null || r[f[0]] === void 0))
          for (var l = 0; l < f.length; l++)
            Wr(f[l]) && (a += sr(i) + ":" + qe(i, f[l]) + ";");
        else {
          var p = Oe(e, r, f);
          switch (i) {
            case "animation":
            case "animationName": {
              a += sr(i) + ":" + p + ";";
              break;
            }
            default:
              process.env.NODE_ENV !== "production" && i === "undefined" && console.error(Ln), a += i + "{" + p + "}";
          }
        }
      }
    }
  return a;
}
var Ur = /label:\s*([^\s;\n{]+)\s*(;|$)/g, ft;
process.env.NODE_ENV !== "production" && (ft = /\/\*#\ssourceMappingURL=data:application\/json;\S+\s+\*\//g);
var J, qr = function(r, n, a) {
  if (r.length === 1 && typeof r[0] == "object" && r[0] !== null && r[0].styles !== void 0)
    return r[0];
  var o = !0, i = "";
  J = void 0;
  var f = r[0];
  f == null || f.raw === void 0 ? (o = !1, i += Oe(a, n, f)) : (process.env.NODE_ENV !== "production" && f[0] === void 0 && console.error(Lr), i += f[0]);
  for (var l = 1; l < r.length; l++)
    i += Oe(a, n, r[l]), o && (process.env.NODE_ENV !== "production" && f[l] === void 0 && console.error(Lr), i += f[l]);
  var p;
  process.env.NODE_ENV !== "production" && (i = i.replace(ft, function(C) {
    return p = C, "";
  })), Ur.lastIndex = 0;
  for (var m = "", d; (d = Ur.exec(i)) !== null; )
    m += "-" + // $FlowFixMe we know it's not null
    d[1];
  var y = Yn(i) + m;
  return process.env.NODE_ENV !== "production" ? {
    name: y,
    styles: i,
    map: p,
    next: J,
    toString: function() {
      return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
  } : {
    name: y,
    styles: i,
    next: J
  };
}, Kn = function(r) {
  return r();
}, Zn = ee["useInsertionEffect"] ? ee["useInsertionEffect"] : !1, Hn = Zn || Kn, Ke = {}.hasOwnProperty, gr = /* @__PURE__ */ ee.createContext(
  // we're doing this to avoid preconstruct's dead code elimination in this one case
  // because this module is primarily intended for the browser and node
  // but it's also required in react native and similar environments sometimes
  // and we could have a special build just for that
  // but this is much easier and the native packages
  // might use a different theme context in the future anyway
  typeof HTMLElement < "u" ? /* @__PURE__ */ $n({
    key: "css"
  }) : null
);
process.env.NODE_ENV !== "production" && (gr.displayName = "EmotionCacheContext");
gr.Provider;
var Xn = function(r) {
  return /* @__PURE__ */ Kr(function(n, a) {
    var o = It(gr);
    return r(n, o, a);
  });
}, ut = /* @__PURE__ */ ee.createContext({});
process.env.NODE_ENV !== "production" && (ut.displayName = "EmotionThemeContext");
var Br = function(r) {
  var n = r.split(".");
  return n[n.length - 1];
}, Qn = function(r) {
  var n = /^\s+at\s+([A-Za-z0-9$.]+)\s/.exec(r);
  if (n || (n = /^([A-Za-z0-9$.]+)@/.exec(r), n))
    return Br(n[1]);
}, ea = /* @__PURE__ */ new Set(["renderWithHooks", "processChild", "finishClassComponent", "renderToString"]), ra = function(r) {
  return r.replace(/\$/g, "-");
}, ta = function(r) {
  if (r)
    for (var n = r.split(`
`), a = 0; a < n.length; a++) {
      var o = Qn(n[a]);
      if (o) {
        if (ea.has(o))
          break;
        if (/^[A-Z]/.test(o))
          return ra(o);
      }
    }
}, dr = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__", pr = "__EMOTION_LABEL_PLEASE_DO_NOT_USE__", lt = function(r, n) {
  if (process.env.NODE_ENV !== "production" && typeof n.css == "string" && // check if there is a css declaration
  n.css.indexOf(":") !== -1)
    throw new Error("Strings are not allowed as css prop values, please wrap it in a css template literal from '@emotion/react' like this: css`" + n.css + "`");
  var a = {};
  for (var o in n)
    Ke.call(n, o) && (a[o] = n[o]);
  if (a[dr] = r, process.env.NODE_ENV !== "production" && n.css && (typeof n.css != "object" || typeof n.css.name != "string" || n.css.name.indexOf("-") === -1)) {
    var i = ta(new Error().stack);
    i && (a[pr] = i);
  }
  return a;
}, na = function(r) {
  var n = r.cache, a = r.serialized, o = r.isStringTag;
  return it(n, a, o), Hn(function() {
    return jn(n, a, o);
  }), null;
}, dt = /* @__PURE__ */ Xn(function(e, r, n) {
  var a = e.css;
  typeof a == "string" && r.registered[a] !== void 0 && (a = r.registered[a]);
  var o = e[dr], i = [a], f = "";
  typeof e.className == "string" ? f = Fn(r.registered, i, e.className) : e.className != null && (f = e.className + " ");
  var l = qr(i, void 0, ee.useContext(ut));
  if (process.env.NODE_ENV !== "production" && l.name.indexOf("-") === -1) {
    var p = e[pr];
    p && (l = qr([l, "label:" + p + ";"]));
  }
  f += r.key + "-" + l.name;
  var m = {};
  for (var d in e)
    Ke.call(e, d) && d !== "css" && d !== dr && (process.env.NODE_ENV === "production" || d !== pr) && (m[d] = e[d]);
  return m.ref = n, m.className = f, /* @__PURE__ */ ee.createElement(ee.Fragment, null, /* @__PURE__ */ ee.createElement(na, {
    cache: r,
    serialized: l,
    isStringTag: typeof o == "string"
  }), /* @__PURE__ */ ee.createElement(o, m));
});
process.env.NODE_ENV !== "production" && (dt.displayName = "EmotionCssPropInternal");
var pt = dt, aa = Re.Fragment;
function G(e, r, n) {
  return Ke.call(r, "css") ? Re.jsx(pt, lt(e, r), n) : Re.jsx(e, r, n);
}
function Gr(e, r, n) {
  return Ke.call(r, "css") ? Re.jsxs(pt, lt(e, r), n) : Re.jsxs(e, r, n);
}
const oa = {
  info: `${re(`--${te}-blue-07`)}`,
  success: `${re(`--${te}-green-07`)}`,
  warning: `${re(`--${te}-orange-07`)}`,
  error: `${re(`--${te}-red-07`)}`
}, Se = {
  info: `${re(`--${te}-blue-03`)}`,
  success: `${re(`--${te}-green-03`)}`,
  warning: `${re(`--${te}-orange-03`)}`,
  error: `${re(`--${te}-red-03`)}`
}, ia = Z`
  display: flex;
  flex-grow: 1;
  margin-right: 8px;
  flex-direction: column;
`, sa = Z`
  margin-right: 8px;
  font-size: 16px;
`, we = Z`
  flex-shrink: 0;
`, ga = Z`
  display: flex;
  flex-direction: row;
  align-items: center;
`, ca = Z`
  font-size: 14px;
  color: ${Zr("gray", "02")};
`, fa = Z`
  font-size: 14px;
  margin-top: 4px;
  color: ${Zr("gray", "04")};
`, ua = Z`
  margin-left: 8px;
`;
function la(e, r, n) {
  const a = r ? Z`` : Z`
        border-radius: 8px;
      `;
  return Z`
    display: flex;
    flex-direction: row;
    padding: 9px 16px;
    font-size: 14px;
    align-items: ${n ? "flex-start" : "center"};
    background-color: ${oa[e]};
    ${a};
  `;
}
const da = {
  enter: {
    opacity: 1,
    transformOrigin: "0% 0%",
    transform: "scaleY(1) translateZ(0)"
  },
  hidden: {
    opacity: 0,
    transformOrigin: "0% 0%",
    transform: "scaleY(0.8) translateZ(0)",
    transition: {
      opacity: { duration: 0.2, ease: "linear" },
      transform: { duration: 0.2, ease: "linear" }
    }
  },
  show: {
    opacity: 1,
    transformOrigin: "0% 0%",
    transform: "scaleY(1) translateZ(0)",
    transition: {
      opacity: { duration: 0.2, ease: "linear" },
      transform: { duration: 0.2, ease: "linear" }
    }
  }
}, pa = Kr((e, r) => {
  const { title: n, action: a, closable: o, type: i = "info", content: f, icon: l, showIcon: p = !0, banner: m, closeElement: d, onClose: y, afterClose: C, ...P } = e, [$, g] = Dt(!0), D = Mt(() => {
    if (p) {
      if (l)
        return G("span", { css: [sa, we], children: l });
      switch (i) {
        case "success":
          return G(zt, { mr: "8px", fs: "16px", mt: f ? "2px" : "0", c: Se.success, css: we });
        case "warning":
          return G(Wt, { mr: "8px", fs: "16px", mt: f ? "2px" : "0", c: Se.warning, css: we });
        case "error":
          return G(Lt, { mr: "8px", fs: "16px", mt: f ? "2px" : "0", c: Se.error, css: we });
        case "info":
          return G(Vt, { mr: "8px", fs: "16px", mt: f ? "2px" : "0", c: Se.info, css: we });
      }
    }
    return G(aa, {});
  }, [f, l, p, i]), _ = Ft((E) => {
    g(!1), y == null || y(E);
  }, [y]);
  return G(Yt, { children: $ && Gr(jt.div, { css: [
    la(i, m, f !== void 0),
    qt(P)
  ], variants: da, animate: "show", exit: "hidden", initial: "enter", ref: r, onAnimationComplete: (E) => {
    E === "hidden" && (C == null || C());
  }, ...Bt(P), children: [D, Gr("div", { css: ia, children: [n && G("div", { css: ca, children: n }), f && G("div", { css: fa, children: f })] }), a, o && G("div", { css: ua, onClick: _, children: d || G(Ut, { c: Se[i], fs: "8px" }) })] }) });
});
pa.displayName = "Alert";
export {
  pa as Alert,
  la as applyAlertContainer,
  ua as closeIconStyle,
  oa as colorMap,
  fa as contentStyle,
  Se as iconColorMap,
  ia as leftContentStyle,
  we as leftIconSizeStyle,
  sa as leftIconStyle,
  ga as titleContainerStyle,
  ca as titleStyle
};
//# sourceMappingURL=index.js.map
